import * as components from "./components"
import * as containers from "./containers"
import * as constants from "./constants"
import * as selectors from "./selectors"
import reducer from "./reducer"

const content = { components, constants, selectors, reducer, containers }
export default content
export const { InvitationDetail, InvitationLoader } = containers
